<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Goods/index.html')">系统设置</div></el-breadcrumb-item>
			<el-breadcrumb-item>品牌授权</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="品牌名称">
				<el-input v-model="item.name" placeholder="品牌名称" size="small"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
			</el-form-item>
		</el-form>

		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['supplier/brandauth/add']">申请新品牌授权</el-button>
<!--			<el-button type="danger" size="small" @click="delAll">批量删除</el-button>-->
		</div>
		<el-table :data="list" border @selection-change="handleSelectionChange">
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="品牌名称"></el-table-column>
			<el-table-column label="授权信息">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img title="Logo" :src="scope.row.logo" height="30" style="display: flex; margin-right: 5px;" />
						<img title="授权证书" :src="scope.row.auth_pic" height="30" style="display: flex; margin-right: 5px;" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="状态">
				<template slot-scope="scope">
					<div class="el-tag el-tag--warning el-tag--small el-tag--dark" v-if="scope.row.status == 1">
						审核中
					</div>
					<div style="" v-if="scope.row.status == -1">
						已拒绝
					</div>
					<div style="" v-if="scope.row.status == 2">
						已通过
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="reason" label="拒绝原因" width="250"></el-table-column>
			<el-table-column prop="created_date" label="申请时间"></el-table-column>
			<el-table-column label="操作" width="160">
				<template slot-scope="scope">
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-if="scope.row.status != 2" v-auth="['supplier/brandauth/delete']">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!--         @size-change="sizeReload"-->
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				// 每页多少条数据
				pageSize: 20,
				pageNum: 0,
				total: 0,
				// 当前在第几页
				page: 1,
				// 查询
				item: {}
			}
		},
		created() {
			this.item = {
					page: this.page,
					limit: this.pageSize
				},
			this.loadList()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/supplier/brandauth/listByPage', this.item)
					.then(res => {
						this.isLoad = !this.isLoad
						// 获取数据
						this.list = res.data.list.data
						// 页数 page
						this.total = res.data.list.total

					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			// 跳转到edit添加
			add() {
				this.$router.push({
					path: '/Settings/brandauthorizingEdit.html'
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Settings/brandauthorizingEdit.html',
					query: {
						id: id
					}
				});
			},
			//
			del(id) {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.delete('/supplier/brandauth/delete', {
					data: {
						ids: id
					}
				})
				.then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '删除成功',
						showClose: false
					});
					this.loadList()
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delAll() {
				let id = []
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					id.push(item.id)
				}
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.delete('/supplier/brandauth/delete', {
					data: {
						ids: id
					}
				}).then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '删除成功',
						showClose: false
					});
					this.loadList()
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			sizeReload(val) {
				// 每页多少条数据
				this.item.pageSize = val
				this.loadList()
			},
			// 修改当前在多少页  修改上一
			pageReload(val) {
				// 当前在第几页
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			// 导出
			excelOut() {
				return;
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('', {
						params: {
							nickname: this.item.nickname,
							title: this.item.title
						}
					})
					.then(res => {
						this.isLoad = !this.isLoad
						// 导出
						window.open(res.url)
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>
